<!--DivUploadItem: 上传文件项 2021/08/04 10:55:53 Sunanguang-->

<template>
   <div class="its-upload-item">
     <i class="its-type-small fl its-file-icon" :class="item.extension | fileIcon"></i>
     <!-- <p class="its-title fl" :title="item.fileName">{{item.fileName}}</p> -->
     <el-input class="its-title fl" v-model="showName" size="small" placeholder="请输入资源标题" maxlength="150"></el-input>
     <p class="its-options fr">
       <template v-if="item.status==='error'">
         <el-tooltip effect="dark" placement="top">
           <p slot="content">{{item.errorMessage}}
             <template v-if="!item.isUpper">
              ，<span class="its-re-upload" @click="uploadAction">重新上传</span>
             </template>
            </p>
          <i class="its-status el-icon-warning"></i>
         </el-tooltip>
          
       </template>
       <template v-else>
         <span v-if="item.statusName && item.statusName === 'progress' || item.percent === 0" class="its-progress">{{item.percent || 0}}%</span>
         <i v-else class="its-status el-icon-success"></i>
       </template>
       <i @click="removeFile" class="its-icon its-icon-shanchu"></i>
     </p>
   </div>
</template>
<script>
export default {
  name: 'DivUploadItem',
  props: {
    fileList: {
      type: Array,
      default: function () {
        return []
      }
    },
    item: {
      type: Object,
      default: function () {
        return {
          extension: 'doc'
        }
      }
    }
  },
  data () {
    return {
      showName: ''
    }
  },
  mounted () {
    // 更新Dom
    console.log('--div-upload-item---', this.item)
    this.showName = this.item.fileName
  },
  computed: {
    fileLength: function () {
      return this.fileList.length
    }
  },
  methods: {
    removeFile: function () {
      this.$emit('remove-file', this.item)
    },
    uploadAction: function () {
      this.$emit('upload-agrin', this.item)
    }
  },
  watch: {
    showName: {
      handler: function () {
        // this.item.showName = this.item.fileName
        this.$set(this.item, 'fileName', this.showName)
        this.$emit('update-list', this.item)
      },
      deep: true
    },
    fileLength: {
      handler: function () {
        // this.item.showName = this.item.fileName
        console.log('----update---file---ss---')
        this.fileList.forEach(file => {
          if (file.id === this.item.id) {
            // this.$set(this.item, 'fileName', this.showName)
            this.showName = this.item.fileName
          }
        })
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped>
.xx-DivUploadItem {
   color: brown;
}

.its-upload-item {
  margin-bottom: 20px;
  padding-left: 0px;
}

.its-upload-item::after {
  clear: both;
  content: '';
  display: block;
}

.its-title {
  margin-left: 10px;
  color: #333333;
  font-size: 14px;
  width: 470px;
}

.its-options {
  width: 60px;
  margin-top: 6px;
}

.its-options span {
  color: #0080FF;
  font-size: 12px;
  cursor: pointer;
  margin-left: 9px;
}

.el-icon-success {
  color: #1CE068;
  font-size: 19px;
}

.el-icon-warning {
  color: #FF7070;
  font-size: 19px;
  cursor: pointer;
}

.its-progress {
  color: #999999 !important;
  font-size: 12px;
  margin-left: 0 !important;
}

.its-file-icon {
  margin-top: 8px;
}

.its-icon-shanchu {
  margin-left: 12px;
  cursor: pointer;
  color: #999999;
  font-size: 17px;
}
</style>
<style>
.its-re-upload {
  color: #5591FE;
  cursor: pointer;
}
</style>
